<div *ngIf="data">
    <app-bread-crumbs [startCategoryId]="data.attributes.category.data.id"></app-bread-crumbs>
    <ng-container *ngIf="data && !data.attributes.full_html_page">
        <div class="row">
            <div class="text-center col-12">
                <h1 class=" text-center d-lg-none"><span i18n="@@p-article">Article:</span> {{data.attributes.article}}</h1>
            </div>

            <div class=" col-12 col-lg-4 text-center">
                <img *ngIf="data.attributes.image && data.attributes.image.data"
                    src="{{ appService.baseUrl + data.attributes.image.data.attributes.url}}"
                    style="max-height:400px; max-width: 100%;" alt="">
            </div>
            <div class="col-xl-6 col-lg-8 col-12 ">

                <h1 class="font-weight-bold d-none d-lg-block">
                    <span i18n="@@p-article">Article:</span> {{data.attributes.article}}
                    <img *ngIf="data && data.attributes.category && data.attributes.category.data &&  data.attributes.category.data.attributes.logo.data"
                        src="{{appService.baseUrl + data.attributes.category.data.attributes.logo.data.attributes.url }}"
                        width="200" alt="" class="img-fluid float-right d-inline">
                </h1>
                <h6 class="line-height-15" [innerHTML]="data.attributes.title">
                </h6>
                <div>
                    <a *ngIf="this.data.attributes.pdf.data" class="main-color px-0"
                        [href]=" appService.baseUrl + this.data.attributes.pdf.data.attributes.url"> <i
                            class="fa fa-lg fa-file-pdf-o"></i> Technical
                        Information for {{data.attributes.article}} </a>
                </div>
            </div>
            <div class="col-2 d-xl-block d-none p-1" *ngIf="productPageData" [innerHTML]="this.sanitizer
        .bypassSecurityTrustHtml(productPageData.attributes.RightPanel)">

            </div>
        </div>

        <section id="services" class="services p-0 pt-2">
            <div class="icon-box">
                <i class="icofont-settings"></i>
                <h4><a href="#" i18n="@@p-configuration">Configuration</a></h4>
                <div class="services-content" *ngIf="data && data.attributes.description" [innerHTML]="this.sanitizer
        .bypassSecurityTrustHtml(data.attributes.description)"></div>
            </div>

        </section>
        <ng-container *ngIf="data.attributes.similar_products && data.attributes.similar_products.data.length > 0">
            <section id="services" class="services p-0 pt-2">
                <div class="icon-box">
                    <i class="fa fa-clone"></i>
                    <h4><a href="#" i18n="@@p-similar-products">Similar products</a></h4>
                    <div class="row similar">
                        <div class="col-12 col-md-4 text-center p-1 "
                            *ngFor="let similar of data.attributes.similar_products.data">
                            <div class="bg-white mr-2 p-1">
                                <a target="_blank"
                                    href='/product/{{appService.getProductIdAndArticle(similar.id, similar.attributes.article)}}'>
                                    <div class="product-img-container">
                                        <img
                                        src="{{ appService.baseUrl + similar.attributes.image.data.attributes.url}}"
                                        alt="" class="product-img">
                                    </div>
                                    <br />
                                    <span [innerHTML]="similar.attributes.title" class="shortText"></span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </ng-container>
    </ng-container>
    <div class="services-content" *ngIf="data && data.attributes.full_html_page" [innerHTML]="this.sanitizer
    .bypassSecurityTrustHtml(data.attributes.full_html_page)"></div>
</div>